import React from 'react';
import { Link } from 'MWC';
import '../less/index.less';
import Calculator from '../../../auxiliary-components/Calculator';
import DownloadApp from '../../Cards/views/downloadApp.c';
import Order from '../../Cards/views/orderAction';
import Banner from "../../../auxiliary-components/shared/Banner";
import green_card_banner_mob from "../img/green_card_banner_mob.png";
import green_card_banner from "../img/green_card_banner.png";
import order_green_card from "../img/odrer_green_card.png";
import TabsNew from "../../../auxiliary-components/shared/TabsNew";
import UsageBlock from "../../../auxiliary-components/shared/UsageBlock";
import TextAboveFooter from "../../../auxiliary-components/shared/TextAboveFooter/views/TextAboveFooter.c";
import Table from "../../../auxiliary-components/shared/Table";
import share_icon from "../../Cards/ProjectSupport/img/share_icon.svg";;
import usage_block_data from "../enums/usage_block_data.json";
import table_data from "../enums/table_data.json";
import FilesForDownload from "../../../auxiliary-components/shared/FilesForDownload/views/file.c";
import scrollToOrder from 'utils/scrollToOrder';
import QuestionsAdminBlock from '../../../auxiliary-components/shared/QuestionsAdmin';
import SliderComponent from "../../../auxiliary-components/shared/Slider";
import { Preloader } from "MWComponents";

export default function template() {
    const isMobile = this.isViewportMobile(),
      {viewport} = this.props,
      modes = [ {mode: 'info', title: 'GREEN_CARD_NAV_TITLE_1'},
          {mode: 'tariffs', title: 'GREEN_CARD_NAV_TITLE_2'},
          {mode: 'questions', title: 'GREEN_CARD_NAV_TITLE_3'}],
      page = 'green-card',
        infoGreen = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Cart/Istot_Zelena_ua.pdf',
        tariffsGreen = 'https://conditions-and-rules.a-bank.com.ua/media/uploads/Tarif/Zelena_ua.pdf',
        termsAndConditions = 'https://conditions-and-rules.a-bank.com.ua/main/view-content-344/?lang=uk',
        model = this.getModel();

    if (model.setRealRate) {
        model.setRealRate(this.l10n('CALCULATOR_CREDIT_CARDS_REAL_YEAR_RATE_1'));
    }

    const calculator = !model.creditSum ? (
        ''
    ) : (
        <div className="credit-calculator">
            <div className="calculator-wrapper">
                <Calculator model={this.getModel()} type="credit_cards" {...this.props} />
            </div>
        </div>
    ),
    isUtm = this.props.location.search.indexOf('utm_') !== -1,
    orderCards = (
        <div className="card-order-wrapper" id='order'>
            <div className="left-side">
                <div className="title">{this.l10n('GC_WANT_TO_ORDER')}</div>
                <div className="sub-title">{this.l10n('GC_WANT_TO_ORDER_SUBTITLE')}</div>
                <div className="card-order">
                    <div className="order-wrapper green-card">
                        <Order
                          {...this.props}
                          row={!this.isViewportMobile()}
                          utmParams={this.utmParams}
                          type="green"
                        />
                    </div>
                </div>
            </div>
            <img className="order-img" alt="order_green_card" src={order_green_card}></img>
        </div>
    ),
    app = isMobile && isUtm ?
      (
        <div className="content">
          {orderCards}
        </div>
      )
      :
      (<div className="download-app-wrapper" id='order'>
        <DownloadApp {...this.props}/>
      </div>);

    return (
        <div className="green-card-block">
          <div className='slider-container'>
            {this.state.loader ? <Preloader></Preloader> : <SliderComponent isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'main_banner')}></SliderComponent>}
          </div>
            <TabsNew modes={modes} isMobile={isMobile} page={'quick-cash'} toggle={this.toggleMode} mode={this.state.mode}>
                <div className="wrapper" type={modes[0].mode}>
                    <div className="content">
                        <UsageBlock isMobile={isMobile} page={page} data={usage_block_data} className="col-3-row-2"></UsageBlock>
                        {calculator}
                        {isMobile ? '' : orderCards}
                    </div>
                  {isMobile ? app : ''}
                </div>
                <div className="wrapper" type={modes[1].mode}>
                    <div className="content">
                      <Table data={table_data} page={page} isMobile={isMobile} toggle={this.toggleMode}></Table>
                      <div className="tariffs-desc">
                        {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_1')}
                        <a className="link" href={tariffsGreen} target="_blank">
                          {this.l10n('PROJECT_SUPPORT_INFO_TARIFFS_DESC_TEXT_2')}
                          <img alt="href_img" src={share_icon}></img>
                        </a>
                      </div>
                    </div>
                  {app}
                </div>
                <div className="wrapper" type={modes[2].mode}>
                  <div className="content">
                    <QuestionsAdminBlock page={page} isMobile={isMobile} widget={this.widgetsHelper.getWidget.call(this, 'questions')}></QuestionsAdminBlock>
                  </div>
                  {app}
                </div>
            </TabsNew>
            <FilesForDownload lang={this.props.lang} widget={this.widgetsHelper.getWidget.call(this, 'files_to_download')}></FilesForDownload>
            <div className={`disclaimer-wrapper tab-${this.state.mode === 'info' ? 'active' : 'hidden'}`}>
                <TextAboveFooter widget={this.widgetsHelper.getWidget.call(this, 'text_above_footer')} />
            </div>
        </div>

    );
}
